export default __webpack_public_path__ + "static/media/10.f6b28076.jpg";